// eslint-disable-next-line no-restricted-imports
import { useRouter as innerUseRouter, NextRouter } from 'next/router';

/** Identical to the version from `next/router`, except it admits it can sometimes
 * return `null`.
 */
export const useRouter: () => NextRouter | null = innerUseRouter;
